<template>
  <div>
    <SidebarLayout
      :breadcrumb="breadcrumb"
      :rootPath="rootPath"
      :pageTitle="pageTitle"
      class="floating-rate-page"
    >
      <template #page-description>
        <p>
          Aqui você pode atualizar valores e descontos base, e visualizá-los no
          <router-link
            class="text-link"
            :to="`/hoteis/calendario-tarifas-allotment/${hotelId}`"
            >Calendário de tarifas e allotment</router-link
          >. Os valores base influenciam em todas as flutuações.
        </p>
      </template>

      <template #sidebar>
        <!-- NOME DO HOTEL -->
        <InfoPanel height="103" class="info-panel">
          <template #content>
            <Heading class="info-panel--title heading--size-2">
              {{ hotel.nome }}
            </Heading>
          </template>
        </InfoPanel>
        <SidebarBlock class="page-actions">
          <PmwHotelNav
            :links="menuLinks"
            :hide="['banners']"
            active="tarifabase"
            class="menu-nav"
          />
          <Heading>Ações da página</Heading>

          <div v-if="selectedTab === 0 || selectedTab === 1">
            <Button
              :disabled="disablePreviewButton"
              tooltipText="Necessário adicionar períodos e valores para adicionar ao calendário"
              tooltipMinWidth="230"
              @click="confirmRatesUpdate()"
            >
              Aplicar ao calendário
            </Button>
          </div>

          <!-- BLACKOUT EM MASSA  -->
          <div v-else>
            <Button
              :disabled="disableApplyBlackout"
              tooltipText="Selecione ao menos uma data e uma tarifa para aplicar o blackout."
              @click="showBlackoutModal = true"
            >
              Aplicar Blackout
            </Button>
          </div>
        </SidebarBlock>
      </template>

      <template #gap-before-content> </template>

      <template #content>
        <Tabs class="tabs-padding" @changeTab="selectedTab = $event">
          <Tab title="Atualização de valores" active>
            <RatesUpdate
              :lockTableEdition="lockTableEdition"
              :floatingData="floatingData"
              :floatingDataValue="floatingDataValue"
              :floatingDataFormated="floatingDataFormated(floatingData)"
              @selectedDay="selectedDay = $event"
              @selectedWeekDays="selectedWeekDays = $event"
              @period="period = $event"
            />
          </Tab>

          <Tab title="Disponibilidade e restrições">
            <RatesRestrictionsClosures
              :rooms="roomsOptions"
              :conflictRestrictions="conflictRestrictions"
              @changeAllotments="restrictions.allotment = $event"
              @changeRestrictions="restrictions.restricoes = $event"
            />
          </Tab>

          <Tab title="Blackout em Massa">
            <MassBlackout
              :saveSucces="blackoutSuccess"
              @datesSelection="selectedBlackoutDates = $event"
              @ratesSelection="selectedBlackoutRates = $event"
            />
          </Tab>
        </Tabs>

        <!-- MODAL DE CONFIRMAÇÃO -->
        <ConfirmationModal
          v-model="showConfirmationModal"
          :selectedWeekDays="selectedWeekDays"
          :periods="period"
          :rooms="roomsOptions"
          :restrictions="formatRestrictionsToSend(restrictions.restricoes)"
          :allotments="formatAllotmentsToSend(restrictions.allotment)"
          :hotel="hotel"
          :floatingData="floatingDataFormated(validFloatingData)"
          @showModal="showConfirmationModal = $event"
          @confirmModal="saveRatesUpdate()"
        />

        <section
          v-if="period.length > 0 && floatingDataValue.length"
          class="table-background"
        >
          <div
            :class="{
              block__disabled: lockTableEdition
            }"
            class="padding-table"
          >
            <SimpleTable
              v-show="selectedTab === 0"
              :columns="roomCols"
              :rows="roomRows"
              :numFormat="true"
              :numberMask="'0.0,[00]'"
              :ignoreNumFormatCols="['quartos', 'diferencial', 'moeda']"
              :highlightFirstRow="true"
              class="simple-table"
            >
              <template #diferencial="{ column }">
                <span class="simple-table--column">{{ column.text }}</span>
              </template>

              <template #moeda="{ column }">
                {{ column.text }}
              </template>

              <template #row-quartos="{ rowItem }">
                <td v-if="rowItem['base']" class="text-left flex-room">
                  <div class="simple-table--room">
                    <span class="font-weight-bold">
                      {{ rowItem['quartos'] }}
                    </span>
                  </div>
                  <span class="font-weight-normal simple-table--base">
                    | Quarto base
                  </span>
                </td>
                <td v-else class="text-left simple-table--cell">
                  <span class="simple-table--room">
                    {{ rowItem['quartos'] }}
                  </span>
                </td>
              </template>

              <template #row-diferencial="{ rowItem }">
                <td
                  :class="getTabledifferentialClass(rowItem['diferencial'])"
                  class="text-right simple-table--cell simple-table--diferencial"
                >
                  <span
                    v-if="+/\-?\d{1,}/gm.exec(rowItem['diferencial'])[0] > 0"
                    >+</span
                  >
                  <span
                    v-else-if="
                      +/\-?\d{1,}/gm.exec(rowItem['diferencial'])[0] < 0
                    "
                    >-</span
                  >
                  {{ rowItem['diferencial'].replace(/-/gim, '') }}
                </td>
              </template>

              <!-- <template #row-moeda="{rowItem}">
                <td class="text-left">
                  {{ rowItem['moeda'] }}
                </td>
              </template> -->
            </SimpleTable>
          </div>

          <section class="section-paragraph">
            <b-row class="row__padding-top">
              <b-col>
                <Paragraph
                  class="section-paragraph--paragraph"
                  font-size="small"
                >
                  O valor do quarto base é usado como referência para os demais.
                  Se necessário, altere o quarto base em
                  <router-link
                    :to="`/hoteis/regras-tarifarias/${hotelId}`"
                    :href="
                      $router.resolve(`/hoteis/regras-tarifarias/${hotelId}`)
                        .href
                    "
                    class="section-paragraph--link primary__color"
                  >
                    Configurações de diferenciais</router-link
                  >.
                </Paragraph>
              </b-col>
            </b-row>
          </section>
        </section>

        <AlertModal
          ref="restricionsAlert"
          v-model="showRestricionsAlert"
          icon="alert"
          title="Ops!"
          confirmButtonText="Voltar e conferir"
          :cancelButtonText="null"
          :buttonClose="true"
        >
          <template #text>
            Alguma de suas restrições entrou em conflito com outra. <br />
            Por favor, confira as linhas em vermelho e tente novamente.
          </template>
        </AlertModal>

        <!-- MODAL COM LOADER -->
        <LoaderModal v-model="showLoaderModal" title="Importante" lockOverlay>
          <template #text>
            Aguarde enquanto atualizamos as informações. <br />
            Isso pode levar alguns minutos.
          </template>
        </LoaderModal>

        <!-- MODAL DE CONFIRMAÇÃO DO BLACKOUT EM MASSA -->
        <BlackoutConfirmationModal
          v-model="showBlackoutModal"
          :selectedDates="selectedBlackoutDates"
          :selectedRates="selectedBlackoutRates"
          @close-modal="blackoutModalEvent"
        />
      </template>
    </SidebarLayout>

    <AlertChip v-model="showAlertConfirmation">
      Estamos salvando suas alterações, avisaremos assim que terminar.
    </AlertChip>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'
import { capitalizeString } from '@/helpers/string'
import SidebarLayout from '@/layouts/SidebarLayout'
import BlackoutConfirmationModal from '@/components/hotel/rates/blackout/BlackoutConfirmationModal'
import MassBlackout from '@/components/hotel/rates/blackout/MassBlackout'
import InfoPanel from '@solucoes/components-lib-tmp/src/components/patterns/InfoPanel'
import SidebarBlock from '@/components/_base/patterns/SidebarBlock'
import Heading from '@/components/_base/elements/Heading'
import Button from '@/components/_base/elements/Button'
import Tab from '@/components/_base/patterns/Tab'
import Tabs from '@/components/_base/patterns/Tabs'
import RatesUpdate from '@/components/hotel/rates/floating/RatesUpdate'
import RatesRestrictionsClosures from '@/components/hotel/rates/restrictions/RatesRestrictionsClosures'
import SimpleTable from '@/components/_base/patterns/SimpleTable'
import Paragraph from '@/components/_base/elements/Paragraph'
import hotelCommonsMixin from '@/mixins/hotelCommonsMixin'
import hotelRatesMixin from '@/mixins/hotelRatesMixin'
import ConfirmationModal from '@/components/hotel/rates/floating/ConfirmationModal'
import AlertModal from '@/components/_base/patterns/AlertModal'
import AlertChip from '@solucoes/components-lib-tmp/src/components/elements/AlertChip'
import LoaderModal from '@/components/_base/commonComponents/LoaderModal'
import hotelRatesConfirmationModalMixin from '@/mixins/hotelRatesConfirmationModalMixin'

export default {
  name: 'FloatingRates',
  mixins: [
    hotelCommonsMixin,
    hotelRatesMixin,
    hotelRatesConfirmationModalMixin
  ],
  components: {
    SidebarLayout,
    BlackoutConfirmationModal,
    MassBlackout,
    InfoPanel,
    SidebarBlock,
    Heading,
    Button,
    RatesUpdate,
    RatesRestrictionsClosures,
    Tab,
    Tabs,
    SimpleTable,
    Paragraph,
    ConfirmationModal,
    AlertModal,
    AlertChip,
    LoaderModal
  },
  data() {
    return {
      roomsOptions: [] /** Opções de quartos */,
      rooms: [] /** Quartos visualizados na tabela */,
      selectedTab: null,
      selectedWeekDays: [] /** Dias da semana selecionados */,
      selectedDay: null /** Dia da semana pré-sizualizado na tabela */,
      value: null /** Tarifa do quarto */,
      period: [] /** Perídos que sofrerão alteração */,
      showLoaderModal: false /** Exibição da modal com loader */,
      showAlertConfirmation: false /** Exibição do toast de feedback */,
      /**
       * Array de objetos das Tarifas Flutuantes
       * @example [
       * {
       *    selectedDays: [],
       *    value: null,
       *    discount: null,
       *    selectedUpdateType: { text: 'Valor', value: 1 }
       *  },
       * ]
       */
      floatingData: [],

      showBlackoutModal: false /** Exibição da modal de blackout */,
      selectedBlackoutDates: [] /** Datas selecioandas para o blackout em massa */,
      selectedBlackoutRates: [] /** Tarifas selecionadas para o blackout em massa*/,
      blackoutSuccess: false /** Se o blackout foi aplicado com sucesso */
    }
  },
  computed: {
    /** Retorna os cabeçalhos possíveis para a tabela */
    roomCols() {
      const columnsArray = [
        { id: 1, text: 'Quartos', value: 'quartos' },
        { id: 2, text: 'Diferencial', value: 'diferencial' }
      ]

      /** Pega o máximo de adultos */
      const maxAdults = Math.max.apply(
        Math,
        this.rooms.flatMap((room) =>
          room.valores
            .filter((val) => val.tipoPax === 10)
            .map((val) => val.quantidadePax)
        )
      )

      /** Pega os valores para crianças */
      const children = this.rooms
        .flatMap((room) => room.valores.filter((val) => val.tipoPax === 8))
        .filter(
          (item, idx, refArr) =>
            refArr.findIndex(
              (refItem) =>
                refItem.idadeMinima === item.idadeMinima &&
                refItem.idadeMaxima === item.idadeMaxima
            ) === idx
        )
        .sort((a, b) => {
          if (a.idadeMinima > b.idadeMinima) return 1
          if (a.idadeMinima < b.idadeMinima) return -1
          return 0
        })

      for (let i = 1; i <= maxAdults; i++) {
        const obj = {
          id: columnsArray.length + i,
          text: `${i} Pax`,
          value: `pax${i}`
        }

        columnsArray.push(obj)
      }

      children.forEach((item, i) => {
        const obj = {
          id: columnsArray.length + i,
          text: `Crian. ${item.idadeMinima}-${item.idadeMaxima}`,
          value: `crian${item.idadeMinima}-${item.idadeMaxima}`
        }

        columnsArray.push(obj)
      })

      /** Adiciona a moeda no final */
      columnsArray.push({
        id: columnsArray.length + 1,
        text: 'Moeda',
        value: 'moeda'
      })

      return columnsArray
    },
    /** Retorna a lista de linhas da tabela */
    roomRows() {
      const rows = []

      this.rooms.forEach((item) => {
        const obj = {
          quartos: capitalizeString(item.nome),
          diferencial:
            item.tipoDiferencial === '%'
              ? `${item.diferencial} ${item.tipoDiferencial}`
              : `${item.tipoDiferencial} ${item.diferencial}`,
          base: this.roomsOptions.find((option) => item.nome === option.nome)
            ?.base
        }

        item.valores.forEach((val) => {
          obj.moeda = item.moeda

          /** Se adultos */
          if (val.tipoPax === 10) {
            obj[`pax${val.quantidadePax}`] = val.valor

            return
          }

          /** Crianças */
          obj[`crian${val.idadeMinima}-${val.idadeMaxima}`] = val.valor
        })

        rows.push(obj)
      })

      return rows
    },
    /** Bloqueia a edição da tabela caso não haja períodos */
    lockTableEdition() {
      let lock = false

      if (!this.period || this.period.length === 0) {
        lock = true
      }

      return lock
    },
    disablePreviewButton() {
      let lock = false /** Bloqueio para tarifas */
      /** Valida se foi selecionado um período para tarifas e não foi adicionado valores */
      if (this.period.length > 0) {
        lock = this.validFloatingData.length === 0
      } else {
        /** ou nenhuma das restrições foi selecionada */
        lock =
          this.restrictions.allotment.length < 1 &&
          Object.keys(this.restrictions.restricoes).every(
            (item) => this.restrictions.restricoes[item].length < 1
          )
      }

      return lock
    },
    /** Pegar os valores válidos das tarifas flutuantes */
    validFloatingData() {
      return this.floatingData.filter((item) => {
        return (
          (item.value !== null || item.discount !== null) &&
          item.selectedDays.length > 0
        )
      })
    },
    /** Formata os dados para o padrão da api */
    formatRoomRates() {
      const obj = {
        tarifas: []
      }

      /** Itera por cada período para criar o objeto */
      this.period.forEach((period) => {
        const finalObj = {
          dataInicial: period.start,
          dataFinal: period.end,
          quartos: []
        }

        /** Itera pelas regras de tarifas definidas */
        this.roomsOptions.forEach((room) => {
          /** Percorrer Tarifas Flutuantes */
          this.floatingData.forEach((item) => {
            const roomObj = {
              codigo: room.codigo,
              diasSemana: item.selectedDays.map((day) => day.value),
              valores: this.buildRoomRulesObj(room),
              tipoAtualizacaoValor: item.selectedUpdateType.value,
              desconto: parseFloat(item.discount),
              valor: parseFloat(
                item.value
              ) /** Preenchido apenas quando é tarifa flutuante */
            }

            finalObj.quartos.push(roomObj)
          })
        })

        obj.tarifas.push(finalObj)
      })

      return obj
    },
    /**
     * Retorna as opções possíveis de hóspedes para os quartos selecionados
     * para ser usada na modal de preview do calendário
     */
    selectedGuestsOptions() {
      const guestsOptions = this.rates.editedRates.reduce((acc, curr) => {
        /** Pega as chaves do objeto e guarda as referentes a hóspedes */
        const paxKeys = Object.keys(curr.rules[0]).filter(
          (item) => item.search(/^(pax|criancas)[0-9]{1,}/gm) > -1
        )

        paxKeys.forEach((key) => {
          const foundAccKey = acc.findIndex((accKey) => accKey.key === key)

          if (foundAccKey < 0) {
            acc.push({
              key: key,
              rooms: [curr.code]
            })
          } else {
            acc[foundAccKey].rooms.push(curr.code)
          }
        })

        return acc
      }, [])

      /** Ordena as opções */
      const pax = guestsOptions
        .filter((item) => item.key.search(/^pax/gim) > -1)
        .sort()
      const children = guestsOptions
        .filter((item) => item.key.search(/^criancas/gim) > -1)
        .sort()

      /** Monta um objeto com o formato aceito pelo componente */
      return [...pax, ...children].map((item) => {
        const obj = {}
        const formatted = item.key.replace(
          /([a-zA-Z]{1,})([0-9]{1,})/gim,
          '$2 $1'
        )

        obj.text = formatted.replace(
          /criancas/gim,
          this.$options.filters.pluralizer(
            item.key.replace(/([^\d])/gim, ''),
            'Criança | Crianças',
            true
          )
        )
        obj.value = item.key

        obj.rooms = item.rooms

        return obj
      })
    },
    /** Dias da semana com atualização de valor */
    floatingDataValue() {
      return this.floatingData.filter(
        (item) => item.selectedUpdateType?.value === 1
      )
    },

    /** Desabilita o botão de aplicar blackout se não houver datas e tarifas selecionadas */
    disableApplyBlackout() {
      return (
        !this.selectedBlackoutDates.length || !this.selectedBlackoutRates.length
      )
    },

    ...mapGetters('hotel', ['getCurrency', 'getResetForm'])
  },
  watch: {
    /** Escuta mudanças no dia da semana selecionado */
    selectedDay() {
      this.updatePreviewData()
    },
    getResetForm(newVal) {
      if (newVal) {
        this.rooms = []
        this.selectedWeekDays = []
        this.selectedDay = null
        this.period = []
        this.floatingData = []
        this.getRatesPreview()
      }
    }
  },
  async created() {
    await this.$room.get(this.hotelId).then((response) => {
      this.roomsOptions = response.data.map((item) => {
        item.nome = capitalizeString(item.nome)

        return item
      })
    })
    /** Inicializa o calendário com os valores zerados */
    this.getRatesPreview()
  },
  methods: {
    /**
     * Evento de blackout em massa
     * @param {boolean} event: se o blackout foi aplicado ou não
     */
    blackoutModalEvent(event) {
      this.showBlackoutModal = false
      if (event === 'success') {
        this.blackoutSuccess = true
        this.selectedBlackoutDates = []
        this.selectedBlackoutRates = []
      }
    },
    /**
     * Busca o preview das tarifas das acomodações
     * para popular a tabela
     *
     * @param {Number} [value] - valor a aplicar
     * @param {Number} [weekDay] - dia da semana que será calculado
     */
    getRatesPreview: debounce(function(value = 0, weekDay = 1) {
      this.$calendar
        .getRatesPreview(this.hotelId, value, weekDay)
        .then((response) => {
          this.rooms = response.data
        })
        .catch((error) =>
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
        )
    }, 1000),

    /**
     * Pega a classe de highlighting para os diferenciais
     *
     * @param {String} differential - diferencial absoluto ou porcentagem
     *
     * @returns {String} classe do diferencial
     */
    getTabledifferentialClass(differential) {
      let tdClass = 'td-zero'
      const diff = differential.toString()

      if (diff.match(/-?\d{1,}/gm) > 0) {
        tdClass = 'td-positive'
      } else if (diff.match(/-?\d{1,}/gm) < 0) {
        tdClass = 'td-negative'
      }

      return tdClass
    },
    /** Formatar os dados para pré-visualização das Tarifas Flutuantes
     * @param {Array} floatingData Array de objetos das Tarifas Flutuantes
     * @example [
     * {
     *    selectedDays: [],
     *    value: null,
     *    discount: null,
     *    selectedUpdateType: { text: 'Valor', value: 1 }
     *  },
     * ]
     */
    floatingDataFormated(floatingData = []) {
      return floatingData.map((item) => {
        /** Tipo de atualização */
        const type = item.selectedUpdateType.value === 2 ? 'Desconto' : 'Valor'
        /** Desconto */
        const discount =
          item.discount === 0 || item.discount === null
            ? '0%'
            : `-${item.discount}%`
        /** Valor */
        const value = item.value === null ? 0 : item.value
        /** Resultado */
        const result =
          item.selectedUpdateType.value === 2
            ? discount
            : this.$options.filters[this.getCurrency](value)
        /** Dias da semana */
        const week = this.formatArrayToString(
          item.selectedDays.flatMap((week) => week.text)
        )
        return {
          week: week || '-',
          type: type,
          result: result
        }
      })
    },
    /** Atualizar a tabela de preview */
    updatePreviewData() {
      /** Pegar a tarifa a partir do dia da semana selecionado */
      const floatingData = this.floatingData.find((item) =>
        item.selectedDays.some((day) => day.value === this.selectedDay?.value)
      )
      /** Verificar se os dados necessários estão preenchidos */
      if ((floatingData?.value, this.selectedDay?.value)) {
        this.getRatesPreview(floatingData.value, this.selectedDay.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$negative: $error;
$positive: $success;
$zero: $gray-mid;

.info-panel {
  background: $pmw-gray-lightest;

  &--title {
    margin-bottom: 0px;
    color: $pmw-gray-darkest;
  }
}

.sidebar-block {
  padding-top: 25px;
}
.menu-nav {
  max-height: calc(100vh - 270px);
  overflow-y: scroll;
}
.alert-chip-success {
  background: $pmw-success;

  &--link {
    text-decoration: underline;
    margin-left: 65px;
  }
}

.page-actions {
  .heading {
    margin-bottom: 15px;
  }

  ::v-deep {
    .button-wrapper {
      & + .button-wrapper {
        margin-top: 10px;
      }
    }
  }
}

.floating-rate-page {
  ::v-deep {
    .content {
      &--white_card {
        padding: 0;
        background-color: $gray-lightest;
      }
    }

    .page-title {
      padding: 40px 50px 56px;
    }

    .tabs {
      &--content {
        padding: {
          bottom: card-spacing('top-medium');
        }
      }
    }
  }

  .section-paragraph {
    background-color: $white;
    padding: {
      top: 22px;
      right: card-spacing('side-large');
      bottom: card-spacing('bottom-large');
      left: card-spacing('side-large');
    }
    &--paragraph {
      color: $gray-dark;
    }
    &--link {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .td-negative {
    color: $negative;
  }
  .td-positive {
    color: $positive;
  }

  .td-zero {
    color: $zero;
  }

  .simple-table {
    color: $gray-table;

    &--base {
      color: $gray-dark;
    }

    &--column {
      width: 100%;
      display: flex;
      padding: 0;
      justify-content: flex-end;
    }

    &--room {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 300px;
      margin-right: 5px;
      color: $gray-darkest;
    }

    .flex-room {
      display: flex;
      white-space: nowrap;
    }
  }
}

.table {
  &-background {
    background-color: $white;

    & ::v-deep .simple-table--body {
      background-color: $gray-lightest;
    }
  }
}
</style>
